import type { CanonicalOrderSnapshot } from '../order/order-finalization.ts';

export function buildAcceptedOrderReportingPayload(order: CanonicalOrderSnapshot) {
  return structuredClone({
    source: order.source,
    channel: order.channel,
    serviceMode: order.serviceMode,
    lineServiceModes: order.lineServiceModes,
    currency: order.currency,
    totalMinor: order.totalMinor,
    authority: order.authority,
    lines: order.lines,
    pricingLines: order.pricingLines,
    pricingAdjustments: order.pricingAdjustments,
    priceResolution: order.priceResolution,
  });
}
